import { WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import { FinalizingGraphState, MetricType } from './Enum';
import constants from '../common/constants';

// Workflow state to metric type
export const workflowStateToMetricMap = new Map<WorkflowState, MetricType>([
  [WorkflowState.DISTRIBUTED, MetricType.Public],
  [WorkflowState.REVOKED, MetricType.ExternalPublished],
  [WorkflowState.FINALIZED, MetricType.ExternalPublished],
  [WorkflowState.FINALIZING, MetricType.TechReview],
  [WorkflowState.PUBLISHED, MetricType.InternalPublished],
  [WorkflowState.REVIEWED, MetricType.PublisherReview],
  [WorkflowState.IN_REVIEW, MetricType.PeerReview],
  [WorkflowState.PENDING_REVIEW, MetricType.PeerReview],
  [WorkflowState.UNPUBLISHED, MetricType.Draft],
  [WorkflowState.REJECTED, MetricType.Draft],
  [WorkflowState.NEW, MetricType.Draft],
  [WorkflowState.UNMODIFIED, MetricType.Draft],
  [WorkflowState.MODIFIED, MetricType.Draft],
]);

export const workflowStateToFinalizingStateMap = new Map<WorkflowState, FinalizingGraphState>([
  [WorkflowState.PUBLISHED, FinalizingGraphState.Unassigned],
  [WorkflowState.FINALIZING, FinalizingGraphState.Finalizing],
  [WorkflowState.FINALIZED, FinalizingGraphState.Finalized],
  [WorkflowState.DISTRIBUTED, FinalizingGraphState.Distributed],
]);

// State ranking map
export const workflowStateRankMap = new Map<WorkflowState, number>([
  [WorkflowState.DISTRIBUTED, 1],
  [WorkflowState.REVOKED, 2],
  [WorkflowState.FINALIZED, 3],
  [WorkflowState.FINALIZING, 4],
  [WorkflowState.PUBLISHED, 5],
  [WorkflowState.REVIEWED, 6],
  [WorkflowState.IN_REVIEW, 7],
  [WorkflowState.PENDING_REVIEW, 8],
  // Draft state
  [WorkflowState.MODIFIED, 9],
  [WorkflowState.UNMODIFIED, 10],
  [WorkflowState.UNPUBLISHED, 11],
  [WorkflowState.REJECTED, 12],
  [WorkflowState.NEW, 13],
]);

// Workflow state to SLA due days
export const stateAndSLADaysMap = new Map<WorkflowState, number>([
  [WorkflowState.REVIEWED, constants.SLA_PUBLISHER],
]);
